/**
 * Notes may contain email/password pairs. Chrome's password manager can freeze the
 * tab when such plaintext appears in the DOM (seen as notes page stuck on "…").
 * Insert a zero-width space after emails so heuristics do not treat the next token
 * as a password, and avoid mailto: autolinks for the same reason.
 */

const EMAIL_THEN_TOKEN =
  /([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})([ \t]+)(\S+)/g;

/**
 * @param {string} text
 * @returns {string}
 */
function neutralizeCredentialPairs(text) {
  if (!text) return "";
  return String(text).replace(EMAIL_THEN_TOKEN, "$1$2\u200b$3");
}

/**
 * @param {import("markdown-it")} md
 */
function disableEmailAutolink(md) {
  if (md && md.linkify && typeof md.linkify.set === "function") {
    md.linkify.set({ fuzzyEmail: false });
  }
  if (md && md.linkify && typeof md.linkify.add === "function") {
    try {
      md.linkify.add("mailto:", null);
    } catch {
      /* ignore */
    }
  }
}

module.exports = {
  neutralizeCredentialPairs,
  disableEmailAutolink,
};
